import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { fetchMenuDataRequest } from '../redux/slices/menuSlice';
import { fetchTpnConfigRequest } from '../redux/slices/tpnConfigSlice';
import { fetchComboRequest } from '../redux/slices/comboSlice';

/**
 * Custom hook to manage menu, combo, and TPN config data fetching
 * Provides data and loading states in a clean interface
 * Only fetches data when a restaurant is selected
 */
export const useMenuAndComboData = () => {
  const dispatch = useAppDispatch();

  // Restaurant selector
  const selectedRestaurant = useAppSelector((state) => state.restaurant.selectedRestaurant);

  // Data selectors
  const menuData = useAppSelector((state) => state.menu.data);
  const menuLoading = useAppSelector((state) => state.menu.loading);

  const comboData = useAppSelector((state) => state.combo.data);
  const comboLoading = useAppSelector((state) => state.combo.loading);

  const tpnConfig = useAppSelector((state) => state.tpnConfig.data);
  const tpnLoading = useAppSelector((state) => state.tpnConfig.loading);

  // Fetch data only when selectedRestaurant exists
  useEffect(() => {
    if (selectedRestaurant) {
      const fetchAllData = () => {
        dispatch(fetchTpnConfigRequest());
        dispatch(fetchMenuDataRequest());
        dispatch(fetchComboRequest());
      };
      fetchAllData();
    }
  }, [selectedRestaurant, dispatch]);
  const isLoading = menuLoading || comboLoading || tpnLoading;

  return {
    menuData,
    comboData,
    tpnConfig,
    menuLoading,
    comboLoading,
    tpnLoading,
    isLoading,
  };
};
